const technologiesList = [
  {name: "Java"},
  {name: "Java Script"},
  {name: "C#"},
  {name: "React"},
  {name: "Type Script"},
  {name: "NodeJS"},
  {name: "MongoDB"},
  {name: "SQL"},
  {name: "Firebase"},
  {name: "Unity"},
  {name: "HTML5"},
  {name: "CSS3"},
  {name: "SCSS"},
  {name: "Swift"},
  {name: "React Native"},
  {name: "IOS"},
  {name: "Android"},
];

export default technologiesList;
